import { FormProvider, useForm } from 'react-hook-form';
import ControlledInput from '../../components/ControlledInput';
import BtnFilled from '../../components/BtnFilled';
import React, { useCallback, useEffect, useState } from 'react';
import { useUserStore } from '../../stores/use-user-store';
import { toast } from 'react-toastify';
import { editOrganization, getUserApi } from '../../api/api';
import { useThrottle } from '../../hooks';
import Modal from '../../components/Modal';
import { Edit } from '@mui/icons-material';

const EditSettingsForm = () => {
  const methods = useForm({ mode: 'onTouched' });
  const { user, setUser } = useUserStore();
  const [showModal, setShowModal] = useState(false);

  const inputs = [
    { name: 'inn', type: 'text', label: 'ИНН', placeholder: 'Укажите ИНН' },
    { name: 'phone', type: 'text', label: 'Телефон', placeholder: '+79311111111', mask: '+79999999999' },
    { name: 'description', type: 'text', label: 'Описание', placeholder: 'Введите описание' },
  ];

  const handleSuccess = async () => {
    toast.success('Данные успешно обновлены');
    await getUserApi(function (data) {
      setUser(data);
    });
  };

  const throttleSubmit = useThrottle(async (data) => {
    await editOrganization(data, handleSuccess, () => toast.error('Произошла ошибка при обновлении данных'));
  }, 500);

  const handleSubmit = useCallback(
    (data) => {
      throttleSubmit(data);
    },
    [throttleSubmit]
  );

  useEffect(() => {
    if (user) {
      methods.reset({
        phone: user?.phone || '',
        inn: user?.inn || '',
        description: user?.description || '',
      });
    }
  }, [methods, user]);

  return (
    <>
      <button
        className={'absolute hover:bg-orange-500 transition right-4 top-4 flex justify-center items-center bg-black w-10 h-10 rounded-xl'}
        onClick={() => setShowModal(true)}>
        <Edit className="text-white" />
      </button>
      <Modal showSave={false} showModal={showModal} setShowModal={setShowModal} title={'Настройки профиля'}>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(handleSubmit)}>
            {inputs.map((input) => {
              return <ControlledInput key={input.name} {...input} />;
            })}
            <BtnFilled disabled={!methods.formState.isDirty} className={'w-max flex mx-auto'} type={'submit'} title={'Сохранить'} />
          </form>
        </FormProvider>
      </Modal>
    </>
  );
};
export default EditSettingsForm;
